import React from 'react';
import { Autocomplete, TextField, Typography, CircularProgress } from '@mui/material';
import { AddressListBox } from './AddressListBox';
import { IAddressPrediction } from '../ContactAddressData';

interface AddressAutocompleteProps {
  value: string;
  options: IAddressPrediction[];
  loading: boolean;
  disabled: boolean;
  onInputChange: (inputValue: string, reason: string) => void;
  onChange: (selectedOption: IAddressPrediction | null) => void;
  placeholder?: string;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const AddressAutocomplete: React.FC<AddressAutocompleteProps> = ({
  value,
  options,
  loading,
  disabled,
  onInputChange,
  onChange,
  placeholder = "Enter address...",
  onFocus,
  open,
  onOpen,
  onClose,
}) => {
  return (
    <Autocomplete
      freeSolo
      disableCloseOnSelect
      value={value}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.text)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      options={options}
      loading={loading}
      disabled={disabled}
      ListboxComponent={AddressListBox}
      onFocus={onFocus}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      onInputChange={(event, newValue, reason) => {
        onInputChange(newValue, reason);
      }}
      
      onChange={(event, option) => {
        onChange(option as IAddressPrediction | null);
      }}

      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          inputProps={{
            ...params.inputProps,
            maxLength: 30,
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          <Typography variant="body2">{option.text}</Typography>
          <Typography variant="caption" color="textSecondary" sx={{ ml: 1 }}>
            {option.description}
          </Typography>
        </li>
      )}
    />
  );
};